/**
 * Type definitions and configuration for RegistrationFlow and its step components
 */
import FindYourSchool from './steps/FindYourSchool';
import SchoolRegistration from './steps/SchoolRegistration';
import RegistrationSuccess from './steps/RegistrationSuccess';
import IndependentRegistration from './steps/IndependentRegistration';
import CommunityRegistration from './steps/CommunityRegistration';
/**
 * Page step components per userType
 */
export const stepComponentsByUserType = {
    school: [FindYourSchool, SchoolRegistration, RegistrationSuccess],
    community: [CommunityRegistration, RegistrationSuccess],
    independent: [IndependentRegistration, RegistrationSuccess],
};
